// src/components/SEO.jsx
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { SEO_CONFIG, SITE_DEFAULTS } from '../config/seoConfig';

const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  ogType,
  schema,
  noIndex,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Current route ka config dhundo, nahi mila toh empty object
  const routeConfig = SEO_CONFIG[currentPath] || {};

  // Priority: props > routeConfig > site default
  const finalTitle       = title       || routeConfig.title       || 'Business Management Software';
  const finalDescription = description || routeConfig.description || 'Tracklio Hub — All-in-one ERP, CRM, HRMS & MDM platform for businesses in India.';
  const finalKeywords    = keywords    || routeConfig.keywords    || '';
  const finalOgType      = ogType      || routeConfig.ogType      || 'website';
  const finalOgImage     = ogImage     || SITE_DEFAULTS.defaultImage;
  const finalSchema      = schema      || routeConfig.schema      || null;
  const isNoIndex        = noIndex     ?? routeConfig.noIndex     ?? false;

  const fullTitle     = `${finalTitle} | ${SITE_DEFAULTS.siteName}`;
  const canonicalUrl  = `${SITE_DEFAULTS.siteUrl}${currentPath}`;
  const robotsContent = isNoIndex
    ? 'noindex, nofollow'
    : 'index, follow, max-snippet:-1, max-image-preview:large';

  // Schema — single object ya array dono handle karta hai
  const schemas = finalSchema
    ? Array.isArray(finalSchema) ? finalSchema : [finalSchema]
    : [];

  return (
    <Helmet>
      {/* ── Primary SEO ── */}
      <title>{fullTitle}</title>
      <meta name="description"  content={finalDescription} />
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}
      <meta name="robots"  content={robotsContent} />
      <meta name="author"  content={SITE_DEFAULTS.siteName} />
      <link rel="canonical" href={canonicalUrl} />

      {/* ── Open Graph ── */}
      <meta property="og:site_name"    content={SITE_DEFAULTS.siteName} />
      <meta property="og:title"        content={fullTitle} />
      <meta property="og:description"  content={finalDescription} />
      <meta property="og:type"         content={finalOgType} />
      <meta property="og:url"          content={canonicalUrl} />
      <meta property="og:image"        content={finalOgImage} />
      <meta property="og:image:width"  content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale"       content={SITE_DEFAULTS.locale} />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:site"        content={SITE_DEFAULTS.twitterHandle} />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image"       content={finalOgImage} />

      {/* ── JSON-LD Structured Data (single ya multiple schemas) ── */}
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;